<template>
  <div>
    <base-header v-once pageName="홈 편집" :popup="true" :history="'main'"></base-header>

    <section id="wrap">
        <div class="modify-group">
            <h6>순서를 변경해보세요.</h6>
            <draggable tag="div" 
              :list="enableList" 
              group="card" 
              draggable=".ditem" 
              ghost-class="ghost"
              class="modify-list">
              <div 
                v-for="element in enableList" 
                :key="element.cardCd"
                :class="{ditem: element.expoSqnc != -1, excude: element.expoSqnc == -1}"
              >{{element.cardNm}}</div>
            </draggable>
        </div>
        <div class="modify-group">
            <h6>메인화면 비노출</h6>
            <draggable tag="div" 
              :list="disalbeList" 
              group="card" 
              draggable=".ditem" 
              ghost-class="ghost"
              class="modify-list">
              <div 
                v-for="element in disalbeList" 
                :key="element.cardCd"
                class="ditem"
              >{{element.cardNm}}</div>
            </draggable>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="black" @click="onCancel">취소</button>
        <button type="button" class="red" @click="onSave">저장</button>
    </div>
  </div>
</template>

<script>
var draggable = () => import(/* webpackChunkName: "draggable" */ 'vuedraggable');
// import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  data: function data() {
    return {
      enableList:[],
      disalbeList:[],
      editable: true,
      isDragging: false,
      delayedDragging: false
    };
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    onCancel() {
      if(confirm('설정 취소 하시겠습니까?')) {
        this.$router.go(this.$router.currentRoute);
      }
    },
    onSave() {
      var isSave = confirm('설정 저장 하시겠습니까?');
      if(!isSave) {
        return;
      }

      var tmpEnableList =  this.enableList.filter(item=>item.expoSqnc != -1);  
      var enableJsonString = JSON.stringify(tmpEnableList);
      var disableJsonString = JSON.stringify(this.disalbeList);
      console.log(enableJsonString, disableJsonString);

      var param = {};
      param.enableJsonString = enableJsonString;
      param.disableJsonString = disableJsonString;
      // var that = this;
      this.$api.set
      .saveDashboardSetUserInfo(param)
      .then(function (data) {
        console.log("DashboardSet.vue <api.set.saveDashboardSetUserInfo.response>",data);
        // that.$router.go(that.$router.currentRoute);
      })
      .catch(function (error) {
        alert(error.rtMsg);
      });
    }
  },
  created: function () {
    var that = this;
    this.$api.set
      .getDashboardSetUserInfo({})
      .then(function (data) {
        console.log("DashboardSet.vue <api.set.getDashboardSetUserInfo.response>",data);
        that.enableList = data.filter(item=>item.expoYn == 'Y');   
        that.disalbeList = data.filter(item=>item.expoYn == 'N');  
        
        var tmp = {
            cardCd: 'NA',
            cardNm: '동기 부여',
            expoSqnc: -1,
            expoYn: 'Y'
        };
        that.enableList.unshift(tmp);
      })
      .catch(function (error) {
        alert(error.rtMsg);
      });
  },
  beforeUpdate: function () {},
};
</script>

<style scoped>
.modify-list div.excude {background: none;}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>